import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { PagosService } from '../../../../services/pagos.service';
import { HelpersService } from '../../../../services/tools/helpers.service';

@Component({
  selector: 'app-modal-confirmacion-pagos',
  templateUrl: './modal-confirmacion-pagos.component.html'
})
export class ModalConfirmacionPagosComponent implements OnInit {
    @Output() afterPaymentsMade: EventEmitter<any> = new EventEmitter;
    @ViewChild('content') private content: TemplateRef<any>;

    public modal: any = null;
    public paymentsToDo: any [] = [];
    public totalPaymentAmout: any = 0;
    public convenio: any = {};
    public loading: boolean = false;

    //Model
    public paymentDate: any = {};

    constructor(private modalService: NgbModal,
        private pagosService: PagosService,
        private helperService: HelpersService) { 
    }

    ngOnInit() {
      this.paymentDate = this.helperService.dateToObj(new Date())
    }    

    public openModal(paymentsToDo: any [], convenio: any) {
        this.paymentsToDo = paymentsToDo;
        this.convenio = convenio;

        //Calcular el pago total
        let totalPaymentAmout = 0;
        this.paymentsToDo.forEach(payment => {
            totalPaymentAmout += payment.monto_pago;
        });

        this.totalPaymentAmout = totalPaymentAmout.toFixed(2);

        this.modal = this.modalService.open(this.content);
    }

    public makePayments(){

        this.loading = true;

        let payments = {
            pagos: this.paymentsToDo,
            fecha_pago: this.helperService.dateToString(this.paymentDate)
        };

        this.pagosService.makePayments(payments).subscribe(
          (response)=>
          {
            const jsonResult = response.json();

            this.helperService.notification('Pagos realizados', 'Se han registrado exitosamente los pagos', 'success');
            this.closeModal()
            this.afterPaymentsMade.emit();
            
            this.loading = false;
          }, error =>
          {
            this.loading = false;
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            console.log('#Error', error);
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    public closeModal() {
        this.modal.close();
    }
}


// WEBPACK FOOTER //
// ./src/app/convenios/pagos-multiples/components/modal-confirmacion-pagos/modal-confirmacion-pagos.component.ts